'use client';

import React from 'react';
import {
  MediaDeviceMenu,
  TrackReference,
  TrackToggle,
  useLocalParticipant,
  VideoTrack,
} from '@livekit/components-react';
import { LocalVideoTrack, Track } from 'livekit-client';
import { BackgroundPicker } from '@/components/room/BackgroundPicker';
import { useCameraBackground } from './useCameraBackground';
import { ru } from './ru';

export function CameraSettings() {
  const { cameraTrack, localParticipant } = useLocalParticipant();
  // Also keeps the camera track in sync where this menu is the only picker
  // on screen (the /custom page uses LiveKit's own control bar).
  const { hasCamera } = useCameraBackground();

  const camTrackRef: TrackReference | undefined = React.useMemo(() => {
    return cameraTrack
      ? { participant: localParticipant, publication: cameraTrack, source: Track.Source.Camera }
      : undefined;
  }, [localParticipant, cameraTrack]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      {camTrackRef && (
        <VideoTrack
          style={{
            maxHeight: '280px',
            borderRadius: '0.625rem',
            objectFit: 'contain',
            objectPosition: 'center',
            transform: 'scaleX(-1)',
          }}
          trackRef={camTrackRef}
        />
      )}

      <section className="lk-button-group">
        <TrackToggle source={Track.Source.Camera}>{ru.camera}</TrackToggle>
        <div className="lk-button-group-menu">
          <MediaDeviceMenu
            kind="videoinput"
            tracks={{ videoinput: cameraTrack?.track as LocalVideoTrack | undefined }}
          />
        </div>
      </section>

      <BackgroundPicker showTitle hasCamera={hasCamera} />
    </div>
  );
}
